import { WechselGrund } from '@ps20/bff-models';
import { App, expandAppTypes, FremdVNVorvertrag } from '@ps20-frontend/frontend-models';
import type { IAppState } from '../localStore';
import { StatePreV29, StateV29 } from './29_migrate_vn_wechselgrund_tkv.interface';

const TKV_APPS = expandAppTypes([App.TKV]);

const migrateFremdVNVorvertrag = (vorvertrag: FremdVNVorvertrag): FremdVNVorvertrag => {
  if (!vorvertrag.vnWechselGrund?.length) {
    return vorvertrag;
  }
  return {
    ...vorvertrag,
    vnWechselGrund: vorvertrag.vnWechselGrund.map(grund =>
      TKV_APPS.includes(grund.appId) && grund.value === WechselGrund.EIGENTUM_WECHSEL
        ? { ...grund, value: WechselGrund.BESITZWECHSEL_TIER, text: 'Besitzwechsel Tier' }
        : grund,
    ),
  };
};

export const migrateVnWechselgrundTkv = (
  previousState: StatePreV29,
  newVersion: number,
  context?: IAppState,
): StateV29 => {
  const tkvZuechterActive = context?.transientState?.featureToggles?.['TKV_ZUECHTER'] === true;
  if (!tkvZuechterActive || !previousState.vnWechselAngaben?.angabenListe?.length) {
    return { ...previousState, version: newVersion };
  }
  return {
    ...previousState,
    version: newVersion,
    vnWechselAngaben: {
      ...previousState.vnWechselAngaben,
      angabenListe: previousState.vnWechselAngaben.angabenListe.map(angabe => ({
        ...angabe,
        fremdVNVorvertraege: angabe.fremdVNVorvertraege?.map(migrateFremdVNVorvertrag),
      })),
    },
  };
};
